import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import { BoxProps, Stack, Typography } from '@mui/material';

interface Props extends BoxProps {
  description: string;
  benefits: string[];
}

export const TutorPlanCardBenefits: React.FC<Props> = ({
  description,
  benefits,
  ...props
}) => {
  return (
    <Stack spacing={2} justifyContent="center" {...props}>
      <Typography
        fontWeight={500}
        fontSize={16}
        color="#4B4B4B"
        ml={5}
        textAlign="center"
      >
        {description}
      </Typography>

      {benefits?.map((item, index) => (
        <Stack
          direction="row"
          key={index}
          alignItems="center"
          spacing={2}
          justifyContent="flex-start"
        >
          <CheckIcon color="primary" />

          <Typography
            mr={1}
            fontWeight={400}
            fontSize={'0.9em'}
            color="#7A8388"
          >
            {item}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
